<template>
  <div class="match-bets">
    <div class="row header-bets">
      <div
        class="sport-header-bet"
        v-for="(bet, index) in matchBetsHeaders.slice(0, 5)"
        :key="index">
        <sport-header-bet
          :bet="bet"
          :bet-style="{ betIdWidth: 'large', betNamePosition: 'left' }"
          :special="matchBets[index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          v-if="match.bettingStatus"
          :key="'medium-locked-1:1'">
          <div
            class="match-bet"
            v-for="matchBet in matchBets.slice(0, 5)"
            :key="matchBet.id">
            <match-bet
              :match-bet="matchBet"
              :increase-odd-size="true" />
          </div>
        </div>
        <match-locked
          :match-status-period="match.status.period"
          :key="'medium-locked-2:1'"
          v-else
        />
      </transition>
    </div>
    <div class="row header-bets">
      <div
        class="sport-header-bet"
        v-for="(bet, index) in matchBetsHeaders.slice(5, 10)"
        :key="index">
        <sport-header-bet
          :bet="bet"
          :bet-style="{ betIdWidth: 'large', betNamePosition: 'left' }"
          :special="matchBets[5+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          v-if="match.bettingStatus"
          :key="'medium-locked-2:1'">
          <div
            class="match-bet"
            v-for="matchBet in matchBets.slice(5, 10)"
            :key="matchBet.id">
            <match-bet
              :match-bet="matchBet"
              :increase-odd-size="true" />
          </div>
        </div>
        <match-locked
          :match-status-period="match.status.period"
          :key="'medium-locked-2:2'"
          v-else
        />
      </transition>
    </div>
  </div>
</template>

<script>
import SportHeaderBet from '@/components/common/sport-header-bet/SportHeaderBet.vue';
import MatchBet from '@/components/common/match-bet/MatchBet.vue';
import MatchLocked from '@/components/common/match-locked/MatchLocked.vue';

export default {
  name: 'MatchBets',
  components: {
    SportHeaderBet,
    MatchBet,
    MatchLocked,
  },
  props: {
    match: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      betsCount: 10,
    };
  },
  computed: {
    matchBets() {
      const matchBets = this.$store.getters.getActiveMatchBets(this.match.id, this.betsCount);

      const diff = this.betsCount - matchBets.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i += 1) {
          matchBets.push({});
        }
      }

      return matchBets;
    },
    matchBetsHeaders() {
      const headerBets = [];

      for (let i = 0; i < this.betsCount; i += 1) {
        const matchBet = this.matchBets[i];
        if (matchBet && Object.keys(matchBet).length > 0) {
          headerBets.push(this.$store.state.live.bets[this.match.idSport][matchBet.idBet]);
        } else {
          headerBets.push({});
        }
      }

      return headerBets;
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/style/variables";

.match-bets {
  overflow: hidden;

  .match-bets {
    height: 4.5vh;
    line-height: 4.5vh;
  }
}

.sport-header-bet {
  float: left;
  width: 20%;

  .bet-header {
    .bet-id {
      font-size: inherit;
    }
  }
}

.header-bets {
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }
}
</style>
